import { render, staticRenderFns } from "./Zhlist.vue?vue&type=template&id=d2bb7342&scoped=true"
import script from "./Zhlist.vue?vue&type=script&lang=js"
export * from "./Zhlist.vue?vue&type=script&lang=js"
import style0 from "./Zhlist.vue?vue&type=style&index=0&id=d2bb7342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb7342",
  null
  
)

export default component.exports